import { message } from "antd";
import { baseRequest } from "../../util/Api";
import { v4 } from "uuid";

export const saveNewTrainingVideo = (data) => {
  return new Promise((resolve) => {
    const key = v4();
    message.open({ key, type: 'loading', content: "Menambah video training ..." })
    baseRequest("post", "/training-videos/", null, data)
      .then((newData) => {
        message.success({ key, type: 'success', content: "Menambah video training berhasil" })
        resolve(newData);
      })
      .catch((e) => {
        message.error({ key, type: 'error', content: e })
      });
  });
}

export const getTrainingVideo = (id) => {
  return new Promise((resolve, reject) => {
    baseRequest("get", "/training-videos/" + id)
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        reject(e)
      })
  })
}

export const deleteTrainingVideo = (id) => {
  return new Promise((resolve, reject) => {
    const key = v4()
    message.open({ key, type: 'loading', content: "Menghapus video training ..." })
    baseRequest("delete", "/training-videos/" + id)
      .then((data) => {
        message.success({ key, type: 'success', content: "Menghapus video training berhasil" })
        resolve(data)
      }).catch((e) => {
        reject(e)
      })
  })
}

export const getTrainingVideoTraining = () => {
  return new Promise((resolve, reject) => {
    baseRequest("get", "/training-videos/training")
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        reject(e)
      })
  })
}